import { Button } from '@mui/material'
import { Form, useFormikContext } from 'formik'

import { IAccountLanguagesForm } from 'src/types'

import { LanguagesInput } from './languages-input.component'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const LanguagesForm = () => {
  const { dirty, isSubmitting } = useFormikContext<IAccountLanguagesForm>()
  const classes = useStyles()

  return (
    <Form className={classes.form}>
      <LanguagesInput />
      <Button disabled={!dirty || isSubmitting} type="submit" variant="contained">
        <HelperWrapper t="update-button-text" />
      </Button>
    </Form>
  )
}
